import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import type { ResponsiveImageSet } from '~/types/resource';

interface Props {
  image: ResponsiveImageSet;
  alt: string;
  loading?: 'lazy' | 'eager';
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsiveImage',
  props: {
    image: null,
    alt: null,
    loading: null
  },
  setup(__props: any) {

const props = __props as {
  image: ResponsiveImageSet;
  alt: string;
  loading?: 'lazy' | 'eager';
};


const srcValue = computed(() => {
  if (props.image?.thumbnail?.src) {
    return props.image?.thumbnail.src;
  }
  if (props.image?.thumbnail?.thumbnail) {
    return props.image?.thumbnail.thumbnail;
  }
  return '';
});
const srcset = computed(() => {
  const sm = `${props.image?.thumbnail?.src} 400w`;
  const md = `${props.image?.medium?.src || props.image?.medium?.thumbnail} 600w`;
  return `${sm}, ${md}`;
});

return { __sfc: true,props, srcValue, srcset }
}

})